// src/app/app.module.ts
import {NgModule} from '@angular/core';
import {AppComponent} from './app.component';
import {AppRoutingModule} from './app-routing.module';

// Core and shared modules
import {CoreModule} from './core/core.module';
import {SharedModule} from './shared/shared.module';

// Feature modules
import {MuskokaModule} from './features/muskoka/muskoka.module';
import {TorontoModule} from './features/toronto/toronto.module';

import {TestComponent} from './test.component';
import {OakvilleModule} from "./features/peelhalton/oakville/oakville.module";
import {BurlingtonModule} from "./features/peelhalton/burlington/burlington.module";
import {MississaugaModule} from "./features/peelhalton/mississauga/mississauga.module";


@NgModule({
  declarations: [
    AppComponent, // Only the root component
    TestComponent

  ],
  imports: [
    // Core module (imported only once)
    CoreModule,

    // App routing
    AppRoutingModule,


    // Shared module
    SharedModule,

    // Feature modules
    MuskokaModule,
    TorontoModule,
    OakvilleModule,
    BurlingtonModule,
    MississaugaModule
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
}
